import { AxiosInstance } from 'axios';
import { T_LeadsNature, T_Notification } from 'types/app.type';

import { sentryService } from '@/services/index';

export class NotificationService {
  private notifAgent: AxiosInstance;
  constructor(agent: AxiosInstance) {
    this.notifAgent = agent;
  }
  public getNotifications = async () => {
    try {
      const { data } = await this.notifAgent.get<T_Notification[]>(`/my-account/notification`, {});
      return data;
    } catch (err) {
      sentryService.captureException(err);
      return [];
    }
  };

  public getLeads = async () => {
    try {
      const { data } = await this.notifAgent.get<T_LeadsNature>(`/my-account/lead?type=new`, {});
      return data;
    } catch (err) {
      sentryService.captureException(err);
      return [];
    }
  };
}
